webClient.directive('ngProductMultiDestinationInfo', ['$window', '$timeout', '$i18next', 'templateService', 
    function ($window, $timeout, $i18next, templateService) {
    var directive = {};
    directive.restrict = 'EA';
    directive.scope = {
        product: "=",
        itineraries: "=",
        summary: "=",
        airlines: "=",
        airports: "=",
        cities: "=",
        index: "=",
        equipments: "=",
        cabinclasses: "=",
        requestcabinclass: "=",
        isloadingco2: "="
    };
    directive.link = function ($scope, $element) {

        templateService.compile($scope, $element, 'tpl/_ProductMultiDestinationTPL.html');

        //Initialize Variables
        $scope.siteType = $window.site.type;
        $scope.getTemplateUrl = $window.getTemplateUrl;
        $scope.getStaticFolder = $window.getStaticFolder;
        $scope.enableFreeFlex = window.enableFreeFlex === true;

        $scope.product.itineraries.each(function (it) {
            it.itinerariesOptions.each(function (itOpt) {
                var itOptObj = $scope.itineraries[itOpt.key];
                if (itOptObj != null) {
                    if (itOptObj.productType == 1) {
                        $scope.product.to = true;
                    }
                }
            });
        });

        //Flags
        $scope.enableOption = $window.enableOption && !($window.sessionStorage.getItem('forceUpsell') === 'true' || $window.getUrlVars()['upsell'] === 'true');        
        
        $scope.itineraryVisibleFilter = function (item) {
            return item.visible;
        };
        
        const PaxType = Object.freeze({
            ADULT: 0,
            CHILD: 1,
            BABY: 2
        });

        const BaggagePolicy = Object.freeze({
            PIECE: 0,
            WEIGHT: 2
        })

        const BaggageLocation = Object.freeze({
            HOLD: 0,
            CABIN: 1
        });

        $scope.product.itineraries.each(function (i) {
             if(!i.auxItinerarySelected)
                 i.auxItinerarySelected = i.itinerariesOptions[0].key;

             if (!i.itinerarySelected)
                i.itinerarySelected = i.itinerariesOptions[0].key;

            //Prepare baggage text for each itinerary option
            i.itinerariesOptions.each(function (itOpt) {
                var itOptObj = $scope.itineraries[itOpt.key];
                if (itOptObj != null) {
                    prepareBaggageText(itOptObj);
                }
            });
        })

        //Asignar un proposal detail por defecto para mostrar el prebook y prebookType
        if ($scope.product.auxproposalDetailSelected == undefined) {
            $scope.product.auxproposalDetailSelected = "";

            //Recorremos los itinerarios y formamos la clave de proposal detail tomando la primera opcion de itinerariesOption
            $scope.product.itineraries.each(function (productItinerary) {
                $scope.product.auxproposalDetailSelected += productItinerary.itinerariesOptions[0].key + "|";
            })

            if ($scope.product.auxproposalDetailSelected && $scope.product.auxproposalDetailSelected.endsWith("|"))
                $scope.product.auxproposalDetailSelected = $scope.product.auxproposalDetailSelected.slice(0, -1);

            //Prebook
            $scope.product.preBookType = $scope.product.proposalDetail[$scope.product.auxproposalDetailSelected].preBookType;
            $scope.product.preBook = $scope.product.proposalDetail[$scope.product.auxproposalDetailSelected].preBook;
        }

        $scope.getText = function (key) {
            return window.culture.texts[key];
        };

        function canAddBaggageOnline(itineraryKey) {
            const itinerary = $scope.itineraries[itineraryKey]

            return Array.isArray(itinerary.additionalBaggages) && itinerary.additionalBaggages.length > 0;
        }

        function formatDimensions(dimensions) {
            if (!dimensions) return '';
            const dimText = [dimensions.length, dimensions.width, dimensions.height]
                .map(Number)
                .sort((a, b) => b - a)
                .join(' x ');
            return dimText + ` ${dimensions.unit}`
        }

        function getBaggagesByPaxType(itineraryOption, paxType) {
            if (!itineraryOption.baggages) {
                return null;
            }
            const result = {
                cabin: itineraryOption.baggages.find(bag => bag.paxType === paxType && bag.location === 1) || null,
                hold: itineraryOption.baggages.find(bag => bag.paxType === paxType && bag.location === 0) || null,
            }
            return result;
        }

        function preparePaxBaggageInfo(itineraryOption, baggageInfo, cabinParts, holdParts, paxBaggages) {
            if (!paxBaggages) return;
            if (!paxBaggages.cabin && !paxBaggages.hold) return;

            const canAddBaggage = canAddBaggageOnline(itineraryOption.key);

            const PaxLabel = {
                [PaxType.ADULT]: $i18next.t("airbooking.baggage.adult") + " : ",
                [PaxType.CHILD]: $i18next.t("airbooking.baggage.child") + " : ",
                [PaxType.BABY]: $i18next.t("airbooking.baggage.baby") + " : ",
            };
            let holdNotIncludedText = $i18next.t("airbooking.baggage.nocheckedincluded");
            let cabinNotIncludedText = $i18next.t("airbooking.baggage.nocabinincluded");

            if (paxBaggages.hold) {
                if (paxBaggages.hold.policy == BaggagePolicy.WEIGHT) {//franchise
                    const includedText = $i18next.t("airbooking.baggage.checkedweightincluded", { weight: paxBaggages.hold.weight, count: paxBaggages.hold.quantity || 1 });
                    if (paxBaggages.hold.paxType === PaxType.ADULT) {
                        baggageInfo.hold.tooltipText = includedText;
                        baggageInfo.hold.quantity = paxBaggages.hold.quantity;
                    }
                    baggageInfo.hold.noAbleToAddOnline = false;
                    holdParts.push(PaxLabel[paxBaggages.hold.paxType] + includedText);

                } else if (paxBaggages.hold.policy == BaggagePolicy.PIECE && paxBaggages.hold.quantity > 0) {//piece
                    let includedText = $i18next.t("airbooking.baggage.checkedincluded", { count: paxBaggages.hold.quantity });
                    const weightText = paxBaggages.hold.weight > 0 ? `${paxBaggages.hold.quantity} x ${paxBaggages.hold.weight} kg` : "";
                    includedText += weightText ? ` (${weightText})` : "";

                    if (paxBaggages.hold.paxType === PaxType.ADULT) {
                        baggageInfo.hold.tooltipText = includedText;
                        baggageInfo.hold.quantity += paxBaggages.hold.quantity;
                    }
                    baggageInfo.hold.noAbleToAddOnline = false;
                    holdParts.push(PaxLabel[paxBaggages.hold.paxType] + includedText);
                } else if (paxBaggages.hold.paxType === PaxType.ADULT) {
                    const totalText = canAddBaggage ? holdNotIncludedText + " - " + $i18next.t("airbooking.baggage.addtonextstep") : holdNotIncludedText + " - " + $i18next.t("airbooking.baggage.addairportonly");
                    baggageInfo.hold.tooltipText = totalText;
                    holdParts.push(totalText);
                }
                baggageInfo.hold.noInfo = false;
            }
            if (paxBaggages.cabin) { // bagage cabine
                if (paxBaggages.cabin.quantity > 0 && paxBaggages.cabin.paxType !== PaxType.BABY) {
                    const includedText = $i18next.t("airbooking.baggage.cabinincluded", { count: paxBaggages.cabin.quantity });
                    const weightText = paxBaggages.cabin.weight > 0 ? `${paxBaggages.cabin.quantity} x ${paxBaggages.cabin.weight} kg` : "";
                    const dimensionText = formatDimensions(paxBaggages.cabin.dimensions);
                    const totalText = [weightText, dimensionText].filter(Boolean);

                    if (paxBaggages.cabin.paxType === PaxType.ADULT) {
                        baggageInfo.cabin.tooltipText = includedText;
                        if (totalText.length > 0) {
                            baggageInfo.cabin.tooltipText += ` (${totalText.join(" - ")})`
                        }
                        baggageInfo.cabin.quantity += paxBaggages.cabin.quantity;
                    }
                    let detailText = includedText;
                    if (totalText.length > 0) {
                        detailText += ` (${totalText.join(" - ")})`;
                    }
                    cabinParts.push(PaxLabel[paxBaggages.cabin.paxType] + `${detailText}`);

                    baggageInfo.cabin.noAbleToAddOnline = false;
                } else if (paxBaggages.cabin.paxType === PaxType.ADULT) {
                    const totalText = cabinNotIncludedText + " - " + $i18next.t("airbooking.baggage.addtonextstepcabin");
                    baggageInfo.cabin.tooltipText = totalText
                    cabinParts.push(totalText);
                } else if (paxBaggages.cabin.paxType === PaxType.BABY) {
                    cabinParts.push(PaxLabel[paxBaggages.cabin.paxType] + $i18next.t("airbooking.baggage.unavailableinfo"));
                }
                baggageInfo.cabin.noInfo = false;
            }
        }

        function prepareBaggageText(itineraryOption) {
            const noInfoCabin = $i18next.t("airbooking.baggage.cabinnoinformation");
            const noInfoHold = $i18next.t("airbooking.baggage.checkednoinformation");

            let baggageInfo = {
                cabin: {
                    quantity: 0,
                    tooltipText: noInfoCabin,
                    detailText: noInfoCabin,
                    noInfo: true,
                },
                hold: {
                    quantity: 0,
                    tooltipText: noInfoHold,
                    detailText: noInfoHold,
                    noInfo: true,
                    noAbleToAddOnline: !canAddBaggageOnline(itineraryOption.key),
                }
            };
            itineraryOption.baggageInfo = baggageInfo;

            if (!itineraryOption.baggages) {
                return;
            }

            const cabinParts = [];
            const holdParts = [];

            const adultBaggages = getBaggagesByPaxType(itineraryOption, PaxType.ADULT);
            const childBaggages = getBaggagesByPaxType(itineraryOption, PaxType.CHILD);
            const babyBaggages = getBaggagesByPaxType(itineraryOption, PaxType.BABY);

            preparePaxBaggageInfo(itineraryOption, baggageInfo, cabinParts, holdParts, adultBaggages);
            preparePaxBaggageInfo(itineraryOption, baggageInfo, cabinParts, holdParts, childBaggages);
            preparePaxBaggageInfo(itineraryOption, baggageInfo, cabinParts, holdParts, babyBaggages);

            const adultQuantity = adultBaggages.hold?.quantity
            const childQuantity = childBaggages.hold?.quantity
            const babyQuantity = babyBaggages.hold?.quantity

            const definedQuantities = [adultQuantity, childQuantity].filter(q => q !== undefined);
            const totalBag = definedQuantities.reduce((a, b) => a + b, 0);
            const allEqual = definedQuantities.every(q => q === definedQuantities[0]);

            if (totalBag > 0 && !allEqual && adultBaggages.hold.weight == 0) {
                baggageInfo.hold.tooltipText = getT('airbooking.baggage.paxsbaggagesnotequal')
            }

            baggageInfo.cabin.detailText = cabinParts.length ? cabinParts.join(" | ") : noInfoCabin;
            baggageInfo.hold.detailText = holdParts.length ? holdParts.join(" | ") : noInfoHold;

        }
        

        $scope.onBookingClick = function (_product, _inbound) {
            if (document.getElementById("i-pop-nofee") && document.getElementById("i-pop-nofee").classList.contains("c-show")) {
                document.getElementById("i-pop-nofee").classList.remove("c-show");
                console.log("on ferme");
            } else {
                console.log("on ouvre");
            }            
         };

        $scope.showItineraries = function () {
             if ($scope.product._lateItineraries === undefined) {
                 $scope.product._lateItineraries = $scope.product.itineraries;
                 $scope.product.showRetour = true;
             } else {
                 $scope.product.showRetour = !$scope.showRetour;
             }

         };

        $scope.ffback = function (idx, _event) {
            if ($scope.product.itineraries) {
                $scope.showItineraries();
                _event.stopPropagation();
                $timeout(function () {
                    $window.FFBack(idx);

                    //Remodal workaround
                    $(document).find(".remodal").each(function (a, c) {
                        var d = $(c)
                            , e = d.data("remodal-options");
                        e ? ("string" == typeof e || e instanceof String) && (e = parseOptions(e)) : e = {},
                            d["remodal"]({ hashTracking: false });
                    });
                }, 100, false);
            }
        };

        function parseOptions(str) {
            var obj = {};
            var arr;
            var len;
            var val;
            var i;
            // Remove spaces before and after delimiters
            str = str.replace(/\s*:\s*/g, ':').replace(/\s*,\s*/g, ',');
            // Parse a string
            arr = str.split(',');
            for (i = 0, len = arr.length; i < len; i++) {
                arr[i] = arr[i].split(':');
                val = arr[i][1];

                // Convert a string value if it is like a boolean
                if (typeof val === 'string' || val instanceof String) {
                    val = val === 'true' || (val === 'false' ? false : val);
                }

                // Convert a string value if it is like a number
                if (typeof val === 'string' || val instanceof String) {
                    val = !isNaN(val) ? +val : val;
                }

                obj[arr[i][0]] = val;
            }
            return obj;
        }

        $scope.fsmoothopen = function (_oOpener, _iSmooth, _iToggle, _vToggleClass) {
            if (_oOpener.target)
                _oOpener = _oOpener.target;
            var obj = { oOpener: _oOpener, iSmooth: _iSmooth };
            if (_iToggle) obj.iToggle = _iToggle;

            if (_vToggleClass) obj.vToggleClass = _vToggleClass;

            $window.FSmoothOpen(obj);
        };

        /**
        * ensureSegments
        * @desc To display segment details
        * @param {string} itinerary itineray.key in $scope.itineraries
        */
        $scope.ensureSegments = function (itinerary) {
            if ($scope.itineraries[itinerary]._lateSegments === undefined) {
                $scope.itineraries[itinerary]._lateSegments = $scope.itineraries[itinerary].segments;
            }
        };

        $scope.ffdetb = function (indexProduct, indexItineraryChoise, itineraryChoiseKey, _event) {
            $scope.ensureSegments(itineraryChoiseKey);
            $scope.showDetailsRetour = !$scope.showDetailsRetour;
            _event.stopPropagation();
            $timeout(function () {
                $window.FFDetB(indexProduct + "-" + indexItineraryChoise);
            }, 0, false);
        };

        $scope.$on("onFilterApplied", function (event, args) {
            for (var i = 0 ; i < $scope.product.itineraries.length; i++) {
                var j = 0;
                var firstOptionSet = false;
                while (j < $scope.product.itineraries[i].itinerariesOptions.length && !firstOptionSet) {
                    if ($scope.product.itineraries[i].itinerariesOptions[j].visible) {
                        $scope.selectItineraryChoice(i, $scope.product.itineraries[i].itinerariesOptions[j].key);
                        firstOptionSet = true;
                    }
                    j++;
                }
            }
        });

        /**
        * selectItineraryChoice
        * @desc When the user select an option from many itineraries options        
        * @param {int} indexItinerary The index of the itinerary in product.itineraries array
        * @param {string} indexItineraryChoise the itineraryKey in itinerariesOptions
        */
        $scope.selectItineraryChoice = function (indexItinerary, indexItineraryChoise) {            
            $scope.product.itineraries[indexItinerary].itinerariesOptions.each(function (opt) {                
                if (opt.key == indexItineraryChoise) {
                    $scope.product.auxproposalDetailSelected = "";
                    $scope.product.itineraries[indexItinerary].itinerarySelected = opt.key;
                    $scope.product.itineraries[indexItinerary].auxItinerarySelected = opt.key;
                    $scope.product.itineraries.each(function (iAux) {
                        $scope.product.auxproposalDetailSelected += iAux.auxItinerarySelected+"|";
                    })

                    if( $scope.product.auxproposalDetailSelected &&  $scope.product.auxproposalDetailSelected.endsWith("|"))
                    $scope.product.auxproposalDetailSelected = $scope.product.auxproposalDetailSelected.slice(0, -1);
                    $scope.product.preBookType = $scope.product.proposalDetail[$scope.product.auxproposalDetailSelected].preBookType;
                    $scope.product.preBook = $scope.product.proposalDetail[$scope.product.auxproposalDetailSelected].preBook;
                }
            })
        };

        /**
        * selectProduct
        * @desc Select a product to send the request to new purchase
        * @param {int} productIndex the index of the product in the general list of products
        */
        $scope.selectProduct = function (productIndex, _event) {            
            var productKey = [];
            var merovingioInfo = {};
            merovingioInfo.product = $scope.product;
            merovingioInfo.itineraries = [];

            //Build proposal key
            $scope.product.itineraries.each(function (pItinerary) {
                if (pItinerary.itinerariesOptions.length == 1) {
                    productKey.push(pItinerary.itinerariesOptions[0].key);
                    merovingioInfo.itineraries.push($scope.itineraries[pItinerary.itinerariesOptions[0].key]);
                }
                else {
                    if (pItinerary.itinerarySelected) {
                        productKey.push(pItinerary.itinerarySelected);
                        merovingioInfo.itineraries.push($scope.itineraries[pItinerary.itinerarySelected]);
                    }
                    else {
                        productKey = [];
                        merovingioInfo.itineraries = [];
                    }                                   
                }
            });                        

            if (productKey) {
                var productKeyRequested = productKey.join([separator = '|']);

                if ($scope.product.proposalDetail[productKeyRequested]) {                    
                    var purchaseRequest = {
                        index: $scope.product.proposalDetail[productKeyRequested].index,
                        group: $scope.product.proposalDetail[productKeyRequested].group,
                        proposal: $scope.product.proposalDetail[productKeyRequested].proposal,
                        brandedFares: true,
                        requestId: $scope.summary.requestId
                    };

                    //required to bind jQuery listener
                    $(_event.target).trigger("bookingSelected", { product: $scope.product, itineraries:  merovingioInfo.itineraries, productIndex: productIndex });

                    $scope.$emit("onProductBookingClick", { purchaseRequest: purchaseRequest, merovingioInfo: merovingioInfo });                    
                }                
            }
        };

        //Available Seat
        $scope.availableSeat = function (itinerary) {
            var seats = itinerary.availableSeats;
            if (seats > 0) {
                seats = Math.max(seats, $scope.summary.totalPaxes);
                if (seats > ($scope.summary.totalPaxes + 2))
                    seats = 0; //don't show the seats message
                return seats;
            };
            return seats;
        };
    };
    return directive;
}]);
